const assessments = [
  {
    index: 1,
    question: "ฉันเลือกรับประทานอาหารที่มีไขมันต่ำและโคเลสเตอรอลต่ำเช่นปลา  เนื้อสัตว์ไม่ติดมัน และถั่วเมล็ดแห้งทุกวัน",
    mutlipleAsk: false,
  },
  {
    index: 2,
    question: "ฉันปรึกษาแพทย์หรือบุคลากรทางการแพทย์เมื่อมีอาการผิดปกติของร่างกาย",
    mutlipleAsk: false,
  },
  {
    index: 3,
    question: "ฉันพักผ่อนอย่างเพียงพอ อย่างน้อย วันละ 6-8 ชั่วโมง",
    mutlipleAsk: false,
  },
  {
    index: 5,
    question: "ฉันสามารถแสดงความรู้สึกชมเชยและยินดีกับความสำเร็จของผู้อื่นได้ อย่างไม่ขัดเขิน",
    mutlipleAsk: false,
  },
  {
    index: 6,
    question: "ฉันได้ออกกำลังกายที่ใช้แรงมากเป็นเวลา 20-30 นาที อย่างน้อย 3 ครั้ง/ สัปดาห์ เช่น เดินเร็ว, แอโรบิค, ปั่นจักรยาน",
    mutlipleAsk: false,
  },
  {
    index: 7,
    question: "ฉันได้หาเวลาพักผ่อนในแต่ละวัน เช่น นั่งดูทีวี, นอนเล่น, หรืองีบหลับ",
    mutlipleAsk: false,
  },
  {
    index: 9,
    question: "ฉันได้รักษาสัมพันธภาพที่ดีกับผู้อื่น",
    mutlipleAsk: false,
  },
  {
    index: 10,
    question: "ฉันได้หาโอกาสออกกำลังที่ใช้แรง น้อยหรือปานกลาง (เช่น เดินติดต่อ กันนาน 30-40 นาที อย่างน้อย 5 ครั้ง/สัปดาห์)",
    mutlipleAsk: false,
  },
  {
    index: 11,
    question: "ฉันรับประทานผัก และผลไม้ทุกวัน",
    mutlipleAsk: false,
  },
  {
    index: 12,
    question: "ฉันรู้สึกพอใจในตนเองและไม่มุ่งหวังในสิ่งที่เป็นไปไม่ได้",
    mutlipleAsk: false,
  },
  {
    index: 14,
    question: "ฉันได้ตั้งเป้าหมายของชีวิตในระยะยาว",
    mutlipleAsk: false,
  },
  {
    index: 15,
    question: "ฉันได้คอยสังเกตความผิดปกติของร่างกายด้วยตนเองอย่างน้อยเดือนละครั้ง",
    mutlipleAsk: false,
  },
  {
    index: 16,
    question: "ฉันพยายามหาโอกาสออกกำลังกาย เล็ก ๆ น้อย ๆ ในแต่ละวัน (เช่น เดินเล่นหลังรับประทานอาหาร, เดินขึ้นบันไดแทนการใช้ลิฟต์)",
    mutlipleAsk: false,
  },
  {
    index: 17,
    question: "ฉันบริหารเวลาให้สมดุลย์ระหว่างการทำงานกับการพักผ่อน",
    mutlipleAsk: false,
  },
  {
    index: 19,
    question: "ฉันรู้ว่าอะไรเป็นสิ่งที่สำคัญต่อชีวิตฉัน",
    mutlipleAsk: false,
  },
  {
    index: 20,
    question: "ฉันได้รับความช่วยเหลือและกำลังใจจากพ่อแม่ พี่น้อง ญาติ หรือ เพื่อน ๆ",
    mutlipleAsk: false,
  },
  {
    index: 21,
    question: "ฉันได้หยุดพักทุกครั้งเมื่อรู้สึกว่าเหนื่อย",
    mutlipleAsk: false,
  },
  {
    index: 23,
    question: "ฉันรับประทานอาหารเช้าทุกมื้อ",
    mutlipleAsk: false,
  },
];

const categories = [
  {
    title_en: "Interpersonal relation",
    title_th: "ด้านสัมพันธภาพระหว่างบุคคล",
    questions: [5, 9, 12],
  },
  {
    title_en: "Physical activity",
    title_th: "ด้านการเคลื่อนไหวร่างกาย",
    questions: [6, 10, 16],
  },
  {
    title_en: "Spiritual growth",
    title_th: "ด้านการพัฒนาจิตวิญญาณ",
    questions: [14, 19, 20],
  },
  {
    title_en: "Health responsibility",
    title_th: "ด้านความรับผิดชอบต่อสุขภาพ",
    questions: [2, 15],
  },
  {
    title_en: "Stress management",
    title_th: "ด้านการจัดการกับความเครียด",
    questions: [3, 7, 17, 21],
  },
  {
    title_en: "Nutrition",
    title_th: "ด้านโภชนาการ",
    questions: [1, 11, 23],
  },
];

const choices = [
  {
    title: "ไม่เคย",
    score: 1,
  },
  {
    title: "บางครั้ง",
    score: 2,
  },
  {
    title: "บ่อยครั้ง",
    score: 3,
  },
  {
    title: "สม่ำเสมอ",
    score: 4,
  },
];

export { assessments, categories, choices };
